<template>
    <AdminBlock title="Select Customer">
        <div class="form-group">
            <CustomerSelect
                v-model="form.selectedCustomer"
                remove-margin
                required
            />
        </div>
    </AdminBlock>

    <div v-if="form.selectedCustomer">

        <div class="row">
            <div class="col-lg-7">
                <AdminBlock title="Job">
                    <div class="row">
                        <div class="col-md-6 mb-4 mb-md-0">
                            <div class="form-group">
                                <label for="notes">
                                    <strong>
                                        Internal Notes
                                    </strong>
                                </label>
                                <textarea
                                    class="form-control"
                                    rows="8"
                                    placeholder="Internal Notes"
                                    name="notes"
                                    id="notes"
                                    v-model="form.notes"
                                ></textarea>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="initial_driver_notes">
                                    <strong>
                                        Initial Driver Notes
                                    </strong>
                                </label>
                                <textarea
                                    class="form-control"
                                    rows="8"
                                    placeholder="These notes will appear before any other notes entered later for all movements in the job."
                                    name="initial_driver_notes"
                                    id="initial_driver_notes"
                                    v-model="form.initialDriverNotes"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </AdminBlock>
            </div>
            <div class="col-lg-5">
                <AdminBlock title="Contract">
                    <fieldset>
                        <ContractSelect
                            v-model="form.selectedContract"
                            :customer="form.selectedCustomer"
                            required
                        />
                        <div class="form-group mb-4">
                            <label for="client_ref">
                                <strong>
                                    Purchase Order (Client Ref)
                                </strong>
                            </label>
                            <input class="form-control" placeholder="Client ref" name="client_ref" type="text" id="client_ref" v-model="form.clientRef">
                        </div>
                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">
                                    <ContactSelect
                                        v-model="form.selectedContact"
                                        :customer="form.selectedCustomer"
                                        title="Contact"
                                        remove-margin
                                        required
                                    />
                                </div>
                                <div>
                                    <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#contract_contact_modal">
                                        Create
                                    </button>
                                    <ContactModal
                                        :selected-customer="form.selectedCustomer"
                                        identifier="contract"
                                        :user="user"
                                        @contact-created="contact => { form.selectedContact = contact.data }"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </AdminBlock>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <AdminBlock title="Collection">
                    <fieldset>
                        <div class="form-group mb-4">
                            <label for="collection_date">
                                <strong>
                                    Collection Date
                                    <Required />
                                </strong>
                            </label>
                            <div class="input-group datetime collection-date">
                                <span class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                <input
                                    class="form-control js-flatpickers"
                                    placeholder="yyyy-mm-dd"
                                    id="collection_date"
                                    name="collection_date"
                                    v-model="form.collection.date"
                                    @on-close="form.collection.date = $event"
                                    type="text"
                                >
                            </div>
                        </div>
                        <div class="form-group">
                            <JobTime
                                title="Collection Time"
                                @update-time="val => { form.collection.time = val }"
                            />

                        </div>
                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Collection Location
                                </strong>
                            </label>
                            <GoogleMap
                                map-for="collection"
                                :selected-customer="form.selectedCustomer"
                                :location="form.collection.location"
                                @location-changed="updateCollectionLocation"
                            />
                        </div>
                        <div class="form-group mb-4">
                            <label for="collection_company">
                                <strong>
                                    Collection Company
                                </strong>
                            </label>
                            <input
                                class="form-control"
                                placeholder="Name of company if different from Customer"
                                name="collection_company"
                                v-model="form.collection.company"
                                type="text"
                                id="collection_company"
                            >
                        </div>
                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">
                                    <ContactSelect
                                        v-model="form.collection.contact"
                                        :customer="form.selectedCustomer"
                                        title="Collection Contact"
                                        remove-margin
                                    />
                                </div>
                                <div>
                                    <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#collection_contact_modal">
                                        Create
                                    </button>
                                    <ContactModal
                                        :selected-customer="form.selectedCustomer"
                                        identifier="collection"
                                        :user="user"
                                        @contact-created="contact => { form.collection.contact = contact.data }"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </AdminBlock>
            </div>
            <div class="col-lg-6">
                <AdminBlock title="Delivery">
                    <div class="form-group mb-4">
                        <label for="delivery_date">
                            <strong>
                                Delivery Date
                                <Required />
                            </strong>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </span>
                            <input class="form-control js-flatpickers"
                                   placeholder="yyyy-mm-dd"
                                   id="delivery_date"
                                   name="delivery_date"
                                   v-model="form.delivery.date"
                                   @on-close="form.delivery.date = $event"
                                   type="text"
                            >
                        </div>
                    </div>
                    <div class="form-group ">
                        <JobTime
                            title="Delivery Time"
                            @update-time="val => { form.delivery.time = val }"
                        />
                    </div>
                    <div class="form-group mb-4">
                        <label>
                            <strong>
                                Delivery Location
                            </strong>
                        </label>
                        <GoogleMap
                            map-for="delivery"
                            :selected-customer="form.selectedCustomer"
                            :location="form.delivery.location"
                            @location-changed="updateDeliveryLocation"
                        />

                    </div>
                    <div class="form-group mb-4">
                        <label>
                            <strong>
                                Delivery Company
                            </strong>
                        </label>
                        <input
                            class="form-control"
                            placeholder="Name of company if different from Customer"
                            name="delivery_company"
                            v-model="form.delivery.company"
                            type="text"
                            id="delivery_company"
                        >
                    </div>
                    <div class="form-group">
                        <div class="d-flex align-items-end">
                            <div class="me-4" style="flex: auto;">
                                <ContactSelect
                                    v-model="form.delivery.contact"
                                    :customer="form.selectedCustomer"
                                    title="Delivery Contact"
                                    remove-margin
                                />
                            </div>
                            <div>
                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delivery_contact_modal"
                                >
                                    Create
                                </button>
                            </div>
                            <ContactModal
                                :selected-customer="form.selectedCustomer"
                                identifier="delivery"
                                :user="user"
                                @contact-created="contact => { form.delivery.contact = contact.data }"
                            />
                        </div>
                    </div>
                </AdminBlock>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <AdminBlock title="Route">
                    <EstimateRoute
                        :collection="{
                            lat: form.collection.latitude,
                            lng: form.collection.longitude
                        }"
                        :delivery="{
                            lat: form.delivery.latitude,
                            lng: form.delivery.longitude
                        }"
                        :mileage="form.mileage"
                        @update-mileage="val => { form.mileage = val }"
                    />
                </AdminBlock>
            </div>
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-12">
                        <AdminBlock title="Vehicle">
                            <div class="form-group mb-2">
                                <div class="d-flex align-items-end">
                                    <div class="me-4" style="flex: auto">
                                        <VehicleSelect
                                            :customer="form.selectedCustomer"
                                            :required="true"
                                            v-model="form.selectedVehicle"
                                            :auto-select-single-vehicle="false"
                                            remove-margin
                                        />
                                    </div>
                                    <div>
                                        <span class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#create_vehicle_modal">
                                            Create
                                        </span>
                                        <VehicleModal
                                            :customer="form.selectedCustomer"
                                            identifier="create"
                                            @vehicle-created="vehicle => { form.selectedVehicle = vehicle.data }"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <p class="mb-0">Vehicle will be
                                    <label>
                                        <input type="radio" name="transported" v-model="form.transported" :value="0" />
                                        <strong class="me-2">
                                            Driven
                                        </strong>
                                    </label>
                                    <label>
                                        <input type="radio" name="transported" v-model="form.transported" :value="1" />
                                        <strong>
                                            Transported
                                        </strong>
                                    </label>
                                </p>
                            </div>
                        </AdminBlock>
                    </div>
                    <div class="col-12">
                        <AdminBlock title="Price">
                            <RoutePrice
                                :contract_id="form.selectedContract?.id"
                                :vehicle_id="form.selectedVehicle?.id"
                                :mileage="form.mileage"
                                :price="form.price"
                                @update-price="updatePrice"
                                @update-price-only="updatePriceOnly"
                                @update-adblue="updateAdblue"
                                @update-fuel="updateFuel"
                            />
                        </AdminBlock>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="block block-rounded">
                <div class="block-content block-content-full">
                    <fieldset>
                        <div class="ibox">
                            <div class="ibox-content">
                                <div class="d-flex justify-content-end">
                                    <a href="" class="btn btn-secondary me-2">
                                        View All Jobs
                                    </a>
                                    <button @click="createNewJobRequest" id="create_contact_form_save" class="btn btn-primary">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    import axios from 'axios';
    import flatpickr from 'flatpickr';
    import AdminBlock from '@/components/movements/components/AdminBlock.vue';
    import ContactModal from "@/components/movements/components/ContactModal.vue";
    import CustomerSelect from "@/components/movements/components/CustomerSelect.vue";
    import ContractSelect from "@/components/movements/components/ContractSelect.vue";
    import ContactSelect from "@/components/movements/components/ContactSelect.vue";
    import EstimateRoute from "@/components/movements/components/EstimateRoute.vue";
    import VehicleSelect from "@/components/movements/components/VehicleSelect.vue";
    import GoogleMap from "@/components/movements/components/GoogleMap.vue";
    import VehicleModal from "@/components/movements/components/VehicleModal.vue";
    import RoutePrice from "@/components/movements/components/RoutePrice.vue";
    import Required from "@/components/movements/components/Required.vue";
    import JobTime from "@/components/movements/components/JobTime.vue";
    import { onMounted, reactive, watch, nextTick } from 'vue';
    import { successAlert, errorAlert } from '@/utils';

    const { user } = defineProps({ user: Object });

    const today = new Date().toISOString().slice(0, 10);
    const form = reactive({
        selectedCustomer: null,
        selectedContract: null,
        selectedContact: null,
        selectedVehicle: null,

        clientRef: '',
        notes: '',
        initialDriverNotes: '',

        collection: {
            date: null,
            time: "Any",
            location: null,
            locale: null,
            latitude: null,
            longitude: null,
            company: '',
            contact: null
        },

        delivery: {
            date: null,
            time: "Any",
            location: null,
            locale: null,
            latitude: null,
            longitude: null,
            company: '',
            contact: null
        },

        transported: 0,

        rate: {
            vehicletypeId: null,
            minimumPrice: null,
            minimumPriceMileage: null,
            pricePerMileAfterMin: null
        },

        price: null,
        priceIncludesFuel: false,
        priceIncludesAdblue: false,
        mileage: 0
    });

    const createNewJobRequest = () => {
        const data = {
            customer_id: form.selectedCustomer?.id ?? null,
            notes: form.notes.length > 0 ? form.notes : null,
            initial_driver_notes: form.initialDriverNotes.length > 0 ? form.initialDriverNotes : null,
            contract_id: form.selectedContract?.id ?? null,
            client_ref: form.clientRef.length > 0 ? form.clientRef : null,
            contact_id: form.selectedContact?.id ?? null,
            collection_date: form.collection.date ?? null,
            collection_time: form.collection.time ?? null,
            collection_location: form.collection.location ?? null,
            collection_lat: form.collection.latitude !== null ? Number(parseFloat(form.collection.latitude).toFixed(10)) : null,
            collection_lng: form.collection.longitude !== null ? Number(parseFloat(form.collection.longitude).toFixed(10)) : null,
            collection_locale: form.collection.locale ?? null,
            collection_company: form.collection.company.length > 0 ? form.collection.company : null,
            collectioncontact_id: form.collection.contact?.id ?? null,
            delivery_date: form.delivery.date ?? null,
            delivery_time: form.delivery.time ?? null,
            delivery_location: form.delivery.location ?? null,
            delivery_lat: form.delivery.latitude !== null ? Number(parseFloat(form.delivery.latitude).toFixed(10)) : null,
            delivery_lng: form.delivery.longitude !== null ? Number(parseFloat(form.delivery.longitude).toFixed(10)) : null,
            delivery_locale: form.delivery.locale ?? null,
            delivery_company: form.delivery.company.length > 0 ? form.delivery.company : null,
            deliverycontact_id: form.delivery.contact?.id ?? null,
            mileage: form.mileage,
            vehicle_id: form.selectedVehicle?.id ?? null,
            transported: Number(form.transported),
            rate_vehicletype_id: form.rate.vehicletypeId ?? null,
            rate_minimum_price: form.rate.minimumPrice ?? null,
            rate_minimum_price_mileage: form.rate.minimumPriceMileage ?? null,
            rate_price_per_mile_after_min: form.rate.pricePerMileAfterMin ?? null,
            price: form.price ?? null,
            price_includes_fuel: form.priceIncludesFuel,
            price_includes_adblue: form.priceIncludesAdblue
        };

        axios.post(route('api.movements.jobs.store'), data)
            .then(response => {
                successAlert(response.data.message, 'Job Created', 2000, true)
                    .then(() => {
                        window.location.href = response.data.redirect_url;
                    });
            })
            .catch(error => {
                if (error.response) {
                    errorAlert(error, 'Error Creating Job');
                }
            });
    };

    const updateCollectionLocation = (data) => {
        form.collection.location = data.location;
        form.collection.latitude = data.latitude;
        form.collection.longitude = data.longitude;
        form.collection.locale = data.locale;
    };

    const updateDeliveryLocation = (data) => {
        form.delivery.location = data.location;
        form.delivery.latitude = data.latitude;
        form.delivery.longitude = data.longitude;
        form.delivery.locale = data.locale;
    };

    const updatePrice = (values) => {
        form.price = values.price;
        form.rate.minimumPrice = values.rate.minimum_price;
        form.rate.minimumPriceMileage = values.rate.minimum_price_mileage;
        form.rate.pricePerMileAfterMin = values.rate.price_per_mile_after_min;
        form.rate.vehicletypeId = values.rate.vehicletype_id;
    };

    const updatePriceOnly = (newPrice) => {
        form.price = newPrice;
    };

    const updateAdblue = (value) => {
        form.priceIncludesAdblue = value;
    };

    const updateFuel = (value) => {
        form.priceIncludesFuel = value;
    };

    const initialiseFlatpickr = () => {
        flatpickr('.js-flatpickers', {
            dateFormat: "Y-m-d",
            enableTime: false,
            altInput: true,
        });

        flatpickr('.flatpicker-time-only', {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true,
            altInput: true,
        });
    };

    onMounted(() => {
        initialiseFlatpickr();
    });

    watch(() => form.selectedCustomer, (value) => {
        // Reset dependent values when customer changes
        form.selectedContract = null;
        form.selectedContact = null;
        form.collection.contact = null;
        form.delivery.contact = null;
        form.selectedVehicle = null;

        if (value !== null) {
            // We need to wait for the DOM to finish rendering first
            nextTick(() => {
                initialiseFlatpickr();
            });
        }
    });

</script>
